// Modules
import React, { useEffect } from 'react'
import { Button, Icon } from '@dasa-health/components-react'

// Applicationm
import Error from 'assets/error.svg'

// Component
import { ContainerGlobal, Container, Content, Illustration, Title, FixedButtonWrapper, Subtitle } from './styles'
import { ROUTES_PATH } from 'constants/routesPath'
import { useHistory } from 'react-router-dom'
import { Whatsapp } from '@dasa-health/alma-icons'
import { useTracking } from 'react-tracking'
import { getOrigin } from 'utils'
import { BiometyDataType } from 'typings/unico'
import { UNICO_CONSTANTS } from 'redesign/constants'

export const FaceRecognitionErrorScreen: React.FC = () => {
    const history = useHistory()
    const { trackEvent } = useTracking()
    const biometyDataLS: BiometyDataType = JSON.parse(sessionStorage.getItem(UNICO_CONSTANTS.STORAGE)!)

    function handleClose() {
        history.push(ROUTES_PATH.SIGN_IN)
        return
    }

    const buttonData = {
        href: 'https://api.whatsapp.com/send/?phone=551140202117',
        icon: <Whatsapp />,
        taget: '_blank',
    }

    useEffect(() => {
        trackEvent({
            event: 'funnel_step',
            funnel: {
                name: getOrigin(biometyDataLS?.origin!),
                current_step: 'Modal - Não foi possível validar a conta',
            },
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <ContainerGlobal>
            <Container>
                <Content>
                    <Illustration alt="" data-testid="content-illustration" src={Error} />
                    <Title>Não foi possível validar sua conta</Title>
                    <Subtitle>
                        Fale com a nossa <strong>central de atendimento</strong> pelo <strong>Whatsapp</strong>.
                    </Subtitle>
                    <FixedButtonWrapper>
                        <Button
                            data-testid="content-button"
                            fullWidth={true}
                            onClick={() => window.open(buttonData.href, '_blank')}
                            size="default"
                            type="button"
                            variant="primary"
                        >
                            {buttonData.icon && <Icon>{buttonData.icon}</Icon>}
                            Falar com atendente
                        </Button>
                        <Button
                            data-testid="content-button"
                            fullWidth={true}
                            onClick={() => handleClose()}
                            size="default"
                            type="button"
                            variant="secondary"
                        >
                            Fechar
                        </Button>
                    </FixedButtonWrapper>
                </Content>
            </Container>
        </ContainerGlobal>
    )
}
